import React from 'react';
// import { Link } from 'react-router-dom';
import forkify from '../assets/portfolio/forkify.png';
import bankist from '../assets/portfolio/bankist.png';
import fooders from '../assets/portfolio/fooders.png';
import mapTrack from '../assets/portfolio/mapTrack.png';
import sheetsClone from '../assets/portfolio/sheetsClone.png';
import playStream from '../assets/portfolio/playStream.png';

const Projects = () => {
  // const [demo, setDemo] = useState('');
  // const [code, setCode] = useState('');

  const projects = [
    {
      id: 1,
      src: fooders,
      demo: 'https://fooders-swiggy-clone.netlify.app/',
      code: 'https://github.com/nidhiG30/Namaste-React',
      title: 'Fooders-Swiggy-Clone',
    },
    {
      id: 2,
      src: playStream,
      demo: 'https://playstream-youtube.netlify.app/',
      code: 'https://github.com/nidhiG30/PlayStream',
      title: 'YouTube Clone',
    },
    {
      id: 3,
      src: forkify,
      demo: 'https://forkify-nidhi.netlify.app/',
      code: 'https://github.com/nidhiG30/forkify-app',
      title: 'Online Recipe Book',
    },
    {
      id: 4,
      src: mapTrack,
      demo: 'https://map-track-nidhi.netlify.app/',
      code: 'https://github.com/nidhiG30/Map-Track/tree/master',
      title: 'Workout Tracker',
    },
    {
      id: 5,
      src: bankist,
      demo: 'https://bankist-nidhi.netlify.app/',
      code: 'https://github.com/nidhiG30/Bankist-App',
      title: 'Consumer Website'
    },
    {
      id: 6,
      src: sheetsClone,
      demo: 'https://sheets-clone.netlify.app/',
      code: 'https://github.com/nidhiG30/Sheets-Clone',
      title: 'Google Sheets Clone'
    },
  ];

  return (
    <div
      name="projects"
      className="bg-gradient-to-b from-black
      to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 pt-20">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Projects
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        {/* Structure for card */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {projects.map(({ id, src, demo, code, title }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <div className='font-semibold text-center p-3 text-lime-300'>{title}</div>
              <img
                src={src}
                alt=""
                className="rounded-md hover:scale-105 duration-200"
              />
              <div className="flex items-center justify-center">
                <a href={demo} target="_blank" rel="noreferrer">
                  <button className="w-1/2 px-6 py-3 m-4 duration-400 hover:scale-105">
                    Demo
                  </button>
                </a>
                <a href={code} target="_blank" rel="noreferrer">
                  <button className="w-1/2 px-6 py-3 m-4 duration-400 hover:scale-105">
                    Code
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
